module.exports = __webpack_public_path__ + "img/first-slide-logo.6d8117c7.png";